import { render, staticRenderFns } from "./DashboardClient.vue?vue&type=template&id=049a562f&scoped=true&"
import script from "./DashboardClient.vue?vue&type=script&lang=ts&"
export * from "./DashboardClient.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardClient.vue?vue&type=style&index=0&id=049a562f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a562f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049a562f')) {
      api.createRecord('049a562f', component.options)
    } else {
      api.reload('049a562f', component.options)
    }
    module.hot.accept("./DashboardClient.vue?vue&type=template&id=049a562f&scoped=true&", function () {
      api.rerender('049a562f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClient.vue"
export default component.exports